import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { Filter } from '../../models/filter';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { debounceTime, fromEvent, map, pairwise } from 'rxjs';
import { co } from '@fullcalendar/core/internal-common';


export interface Badge {
  key?: string,
  label: string,
  control: AbstractControl
  position?: number,
  filter?: Filter
}

@Component({
  selector: 'split-filter',
  templateUrl: './split-filter.component.html',
  styleUrls: ['./split-filter.component.scss']
})
export class SplitFilterComponent { 
    @Input() public form!: FormGroup;
    @ViewChild('idInputSearch') public inputSearch: any;

    protected listBadge: Badge[] = [];
    protected showFilter: boolean = false;

    protected filter = new Filter();

    @Output() filterChange = new EventEmitter<Filter>();
    constructor(
      private activatedRoute: ActivatedRoute,
      private location: Location) {}

    ngOnInit(): void {
     let queryParams = this.activatedRoute.snapshot.queryParams;
     const queryString = this.toQueryString(queryParams);
     this.filter.parseQueryParams(queryString);
       console.log(this.filter.filters);
       this.filterChange.emit(this.filter);

     /*this.filter.filters.forEach((filter: any) => {
      let value = this.filter.getFilter(filter.key).map((filter: any) => {
        return filter.value;
      });
      if(Array.isArray(value) && value.length > 0) {
        this.form.get(filter.key)?.setValue(value);
      } else
       this.form.get(filter.key)?.setValue(filter.value);
       this.form.get(filter.key)?.updateValueAndValidity();
       console.log(this.form.get(filter.key)?.value);
     })*/



    for (const key in this.form.controls) {
      const control = this.form.get(key);
      if (control) {
        control.valueChanges.subscribe(value => {
          if(value == null) {
            let list = this.listBadge.filter((badge) => badge.key != key);
            this.listBadge = list;
            this.filter.clearFilter(key);
            this.filter.clearDate("date");
          } else 
          if(Array.isArray(value) && value.length === 2 && value[0] instanceof Date && value[1] instanceof Date) {
            const start = value[0].toLocaleDateString();
            const end = value[1].toLocaleDateString();

            this.filter.date('date', start, 'after');
            this.filter.date('date', end, 'before');
            this.filterChange.emit(this.filter);

            this.listBadge.push({
              key, 
              label: `${start} - ${end}`,
              control,
              filter: this.filter
            });
          } else if(Array.isArray(value) && value.length > 0) {
            let list = this.listBadge.filter((badge) => badge.key != key);
            this.listBadge = list;
            this.filter.clearFilter(key);

            value.forEach((value: any, position: number) => {
              if(value != null && value.name != null) {
                this.filter.filter(key, value.id, 'IN');
                this.listBadge.push({
                  key,
                  label: value.name,
                  control,
                  position,
                  filter: this.filter
                });
              }
            });
            this.filterChange.emit(this.filter);
           
          } else {
            console.log(key);
            let index = this.listBadge.findIndex((badge) => badge.key == key);
            if(index != -1) {
              this.listBadge.splice(index, 1);
            }
            this.filter.clearFilter(key);
            this.filter.filter(key, value.id, 'AND');
            this.filterChange.emit(this.filter);
              this.listBadge.push({
                key,
                label: value.name,
                control,
                filter: this.filter
              });
          }
          this.formatUrl();
        });
      }
    }



      /*this.form.valueChanges.subscribe((value) => {
        this.listBadge = [];
        this.filter.clear();
        Object.values(this.form.controls).forEach((control, index) => {
          let key = Object.keys(this.form.controls)[index];
          if(Array.isArray(control.value)) {
            if(control.value[0] instanceof Date && 
               control.value[1] instanceof Date) {
                this.filter.date('date', control.value[0].toLocaleDateString(), 'after');
                this.filter.date('date', control.value[1].toLocaleDateString(), 'before');
              this.listBadge.push({
                label: control.value[0].toLocaleDateString() + ' - ' + control.value[1].toLocaleDateString(),
                control: control,
                filter: this.filter
              });
            } else {
              control.value.forEach((value: any, position: number) => {
                if(value != null && value.name != null) {
                  this.filter.filter(key, value.id, 'IN');
                  this.listBadge.push({
                    label: value.name,
                    control: control,
                    position: position,
                    filter: this.filter
                  });
                }
              });
            }
          } else {
            if(control.value != null && control.value.name != null) {
              this.filter.filter(key, control.value.id, 'AND');
              this.listBadge.push({
                label: control.value.name,
                control: control,
                filter: this.filter
              });
            }
          }
        })
        let queryParams = this.filter.convertFilterInQuery();
        let path = this.location.path().split('?')[0];
        this.location.replaceState(path, queryParams);
      });*/
    }

     ngAfterViewInit() {
        fromEvent(this.inputSearch.nativeElement, 'input')
          .pipe(
            map((event: any) => event.target.value),
            debounceTime(1000)
          )
          .subscribe((value: any) => {
            this.filter.search(["name"], value);
            this.filterChange.emit(this.filter);
            this.formatUrl();
          });
      }

    private toQueryString(params: any): string {
        const query = Object.entries(params)
          .map(([key, value]) => `${key}=${encodeURIComponent(value as any)}`)
          .join('&');
        return query ? `?${query}` : '';
    }

    private formatUrl() {
        let queryParams = this.filter.convertFilterInQuery();
        let path = this.location.path().split('?')[0];
        this.location.replaceState(path, queryParams);
    }

    removeBadge(badge: Badge) {
      console.log(badge);
      if(badge.position != undefined) {
        badge.control.value.splice(badge.position, 1);
        badge.control.setValue(badge.control.value);
      } else {
        badge.control.setValue(null);
      }
    }

    clearFilter() {
      this.form.reset();
      this.filter.clearAllFilter();
      this.filterChange.emit(this.filter);
    }

}
